<script>
import { service } from "../../../config/transaction"

export default {
  props: {
    filters: {
      default: null
    },
    backend: {
      type: Boolean,
      default: false
    },
    excludes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    filteredRanges: {
      get() {
        return this.queries.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.queries.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    serviceOptions() {
      return Object.values(service).map((s) => ({ value: s, label: s.toUpperCase() }))
    },
  },
  data: () => ({
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
    queries: {
      page: 1,
      q: '',
      date: [],
      service: [],
      products: []
    }
  }),
  methods: {
    autocomplete(v, iteratee) {
      if (v.length === 0) {
        this.queries[iteratee] = []
      } else {
        this.queries[iteratee] = _.map(v, (o) => o.id)
      }
    },
    reset() {
      this.queries = {
        page: 1,
        q: '',
        date: [],
        service: [],
        products: []
      }

      this.submit()
    },
    submit() {
      this.$emit("filtered", this.queries)
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v instanceof Object)
          Object.assign(this.queries, v)
      }
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="queries" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="Keyword">
        <a-input placeholder="Keyword.." v-model="queries.q">
          <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-model-item>

      <a-form-model-item label="Date/Time">
        <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
      </a-form-model-item>

      <a-form-model-item label="Subscriber Id">
        <a-input placeholder="Subscriber Id" v-model="queries.subscriber_id">
          <a-icon slot="prefix" type="idcard" style="color:rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-model-item>

      <a-form-model-item label="Service">
        <a-checkbox-group v-model="queries.service" :options="serviceOptions" />
      </a-form-model-item>

      <a-form-model-item label="Product">
        <product-autocomplete :routeName="backend ? 'hyperion.product' : 'report.product'" style="width: 100%" @change="(item) => autocomplete(item, 'products') "/>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 18, offset: 6}">
        <a-space>
          <a-button type="primary" @click="submit" icon="filter">Filter</a-button>
          <a-button class="ml-2" icon="reload" @click="reset">Reset</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
